import { GridColDef, GridRowsProp } from '@mui/x-data-grid';
import { useContext, useEffect, useState } from 'react';
import { AppContext } from '../../app-context';
import IGridComponent from '../../components/grid/i-grid.component';
import TitlePanel from '../../components/title-panel/title-panel.component';
import { ALL, PAGE_SIZE } from '../common/constants';
import { formatDate, isEmpty, isEmptyArray } from '../common/util.services';
import './task.scss';
import { getGeneralTask } from './task.services';
import SearchPanel from '../../components/search-panel/search-panel.component';
import { Box, Grid, Tooltip } from '@mui/material';
import IDropdown from '../../components/text-component/dropdown/i-dropdown.component';

const MyTaskList = () => {
  const appContext = useContext(AppContext);
  const rows: GridRowsProp = [];
  const [taskData, setTaskData] = useState(rows);
  const [searchData, setSearchData] = useState<any>({priority: ALL, status: ALL});
  const popperProps = {sx: {'.MuiTooltip-tooltip': {bgcolor: 'ivory', fontSize: 16, color: 'black', border: 1}}};
  const columns: GridColDef[] = [
    { field: 'task', headerName: 'Task', filterable: false, sortable: false, editable: false, width: 500 },
    { field: 'creationDate', headerName: 'Creation Date', filterable: false, sortable: false, editable: false, width: 110,
      valueFormatter: (value: any) => formatDate(value)
    },
    { field: 'taskCreator', headerName: 'Task Creator', filterable: false, sortable: false, editable: false, width: 110},
    { field: 'priority', headerName: 'Priority', filterable: false, sortable: false, editable: false, width: 75,
      cellClassName: (params) => { return params.row.priority}
    },
    { field: 'targetDate', headerName: 'Target Date', filterable: false, sortable: false, editable: false, width: 100,
      valueFormatter: (value: any) => formatDate(value),
      renderCell: (params: any) =>  (<Tooltip title={getTooltip(params.row.targetHistory)}
      PopperProps={popperProps}>{<Box>{formatDate(params.row.targetDate)}</Box>}</Tooltip>)
    },
    { field: 'ageing', headerName: 'Ageing', filterable: false, sortable: false, editable: false, width: 65,
      valueFormatter: (value: any) => isEmpty(value) ? 'NA' : value
    },
    { field: 'daysLeft', headerName: 'Days Left', filterable: false, sortable: false, editable: false, width: 80,
      valueFormatter: (value: any) => isEmpty(value) ? 'NA' : value
    },
    { field: 'status', headerName: 'Status', filterable: false, sortable: false, editable: false, width: 95,
      cellClassName: (params) => { return params.row.status}
    },
    { field: 'remarks', headerName: 'Remarks', filterable: false, sortable: false, editable: false, width: 180 },
  ];
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(PAGE_SIZE);
  const [totalRows, setTotalRows] = useState(0);

  useEffect(() => {
    if (isEmptyArray(rows)) {
      searchData.myTask = true;
      getGeneralTask(searchData, page, pageSize, appContext,
        (response: any) => {
          setTaskData(response.data.content);
          setTotalRows(response.data.totalElements);
          appContext.setShowLoader(false);
          setLoading(false);
        }, (error: any) => {
          console.log(error);
          appContext.setShowLoader(false);
          appContext.setErrorMessage(error.message);
          setLoading(false);
        });
    }
  }, [searchData, page, pageSize]);

  const onPaginationModelChange = (evt: any) => {
    setPage(evt.page);
    setPageSize(evt.pageSize);
  }

  const search = (data: any) => {
    setSearchData(data);
  }

  function getTooltip(target: string[]) {
    let array: any[] = ['History:'];
    if(isEmptyArray(target)) {
      array.push('NA')
    }
    for(let i = 0; i < target.length; ++i) {
      array.push(target[i]);
    }

    let newText = array.map(i => {
      return <p>{i}</p>
    });

    return newText;
  }

  const getSearchComponent = () => {
    return <SearchPanel search={search} formData={searchData}>
      <Grid container spacing={1}>
        <Grid xs={6}>
          <IDropdown name='priority' label='Priority' itemList={['Low', 'Medium', 'High']} allItemRequired={true} />
        </Grid>
        <Grid xs={6}>
          <IDropdown name='status' label='Status' itemList={['Completed', 'Pending']} allItemRequired={true} />
        </Grid>
      </Grid></SearchPanel>
  }

  const getMainPanel = () => {
    return <>
      {getSearchComponent()}
      <IGridComponent title={''} rows={taskData} columns={columns} loading={loading} maxHeight={500}
        paginationType="server" paginationModelChange={onPaginationModelChange} totalRows={totalRows}
        getRowId={(row: any) => row.rowId} showAction={false}/>
    </>
  }

  return <TitlePanel title={'My Tasks'} panelBody={getMainPanel()} />
}

export default MyTaskList;